<template>
    <svg class="account-ui-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">
        <template v-if="name === 'lock'">
            <rect x="5" y="10" width="14" height="12" rx="3" />
            <path d="M8 10V6a4 4 0 0 1 8 0v4M12 15v3" />
        </template>
        <template v-else-if="name === 'user'">
            <circle cx="12" cy="7" r="4" /><path d="M4 22v-2a8 8 0 0 1 16 0v2" />
        </template>
        <template v-else-if="name === 'settings'">
            <path d="m10 2-.6 3-2 .9L4.8 4.4 2.4 8.6l2.3 2v2.8l-2.3 2 2.4 4.2 2.6-1.5 2 .9.6 3h4l.6-3 2-.9 2.6 1.5 2.4-4.2-2.3-2v-2.8l2.3-2-2.4-4.2-2.6 1.5-2-.9L14 2h-4Z" /><circle cx="12" cy="12" r="3.5" />
        </template>
        <template v-else-if="name === 'phone'">
            <path d="m5 3 3-1 3 5-2 2c1.2 3 3 4.8 6 6l2-2 5 3-1 3c-.4 1.2-1.5 2-2.8 1.8C9.8 19.8 4.2 14.2 3.2 5.8 3 4.5 3.8 3.4 5 3Z" />
        </template>
        <template v-else-if="name === 'calendar'">
            <rect x="3" y="5" width="18" height="17" rx="2" /><path d="M7 2v6M17 2v6M3 11h18" />
        </template>
        <template v-else-if="name === 'game'">
            <path d="M7 6h10c2 0 3 1 3.5 3l2 9c.5 2-1.5 3-3 1l-3-4h-9l-3 4c-1.5 2-3.5 1-3-1l2-9C4 7 5 6 7 6Z" /><path d="M7 9v5M4.5 11.5h5M16 10h.1M19 13h.1" />
        </template>
        <template v-else-if="name === 'gift'">
            <path d="M3 9h18v4H3zM5 13v9h14v-9M12 9v13M12 9C7 9 5 7 5 5a3 3 0 0 1 6 0l1 4Zm0 0c5 0 7-2 7-4a3 3 0 0 0-6 0l-1 4Z" />
        </template>
        <template v-else-if="name === 'copy'">
            <rect x="8" y="7" width="12" height="15" rx="2" /><path d="M16 7V4a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h3" />
        </template>
        <template v-else-if="name === 'favorite'">
            <path d="M12 13 4 6a4 4 0 0 1 8-3 4 4 0 0 1 8 3l-8 7ZM8 17h12M8 21h9" /><circle cx="3" cy="17" r=".7" /><circle cx="3" cy="21" r=".7" />
        </template>
        <template v-else-if="name === 'record'">
            <path d="M14 2H5a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V9l-7-7ZM14 2v7h7M7 13h10M7 17h10" />
        </template>
        <path v-else-if="name === 'close'" d="m5 5 14 14M19 5 5 19" />
        <path v-else-if="name === 'chevron'" d="m9 4 8 8-8 8" />
        <path v-else-if="name === 'down'" d="m5 9 7 7 7-7" />
        <template v-else-if="name === 'hidden'">
            <path d="m3 3 18 18M10 5a13 13 0 0 1 2-.2c6 0 10 7.2 10 7.2a19 19 0 0 1-4 4M6 6C3.5 8.1 2 12 2 12s4 7.2 10 7.2c1.7 0 3.2-.5 4.5-1.2" /><path d="M9 9a4 4 0 0 0 6 6M13 8a4 4 0 0 1 3 3" />
        </template>
        <template v-else-if="name === 'visible'">
            <path d="M2 12s4-7.2 10-7.2S22 12 22 12s-4 7.2-10 7.2S2 12 2 12Z" /><circle cx="12" cy="12" r="3.5" />
        </template>
        <template v-else-if="name === 'info'">
            <circle cx="12" cy="12" r="10" /><path d="M12 11v6M12 7h.01" />
        </template>
        <template v-else-if="name === 'search'">
            <circle cx="10" cy="10" r="7" /><path d="m15 15 7 7" />
        </template>
    </svg>
</template>
<script>
export default {
    name: 'AccountUiIcon',
    props: { name: { type: String, required: true } }
}
</script>
<style scoped>
.account-ui-icon { width: 24px; height: 24px; flex: 0 0 auto; display: block; }
</style>
